import * as _ from "lodash";
import * as angular from "angular";
import { Effort } from "../../models/effort.model";
import { Campaign } from "../../models/campaign.model";
import { Filter } from "../../models/filter.model";
import { User } from "../../models/user.model";
import { EventModel } from "../../models/event.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { ScreenUtils } from "../../helper/screen.helper";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { EventDataProvider } from "../../data-provider/event.dp";
import { UserDataProvider } from "../../data-provider/user.dp";
import { PermissionCheck } from "../../shared/permission";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Team } from "../../models/team.model";
import { Utils } from "../../helper/utils.helper";
import { GroupDataProvider } from "../../data-provider/group.dp";
import { Group } from "../../models/group.model";
import { ToastUtils } from "../../helper/toast.helper";

let CreateEventComponent = {
    selector: "vcCreateEvent",
    templateUrl: "/angular/components/event/create-event.component.html",
    bindings: {},
    controller: class CreateEventController {
        public isOrgCampaign: boolean;
        public activeCampaign: Campaign;
        public activeStep = 1;
        public preview = "desktop";
        public view: string;
        public efforts: Effort[] = [];
        public image: any = null;
        public today = new Date();
        public search = { user: "" };
        public permissions: object[];
        public eventId: number | string;
        public loadingClashingEvents = false;
        public validationError = {
            valid: true,
            message: null,
        };
        public validationErrors: any;
        public event: EventModel;
        public searchDelay: any;
        public filter: any;
        public steps: number[] = [];
        public datesError = "";
        public createEventForm: any;
        public permissionsError: string | null = null;
        public usersError: string | null = null;
        public teamsError: string | null = null;
        public clashingEvents: Array<EventModel>;
        public alreadyUsedLiceses = 0;
        public eventError = false;
        public filteredUsers: User[];
        public groupFilter: Filter;
        public groups: Group[];
        public accountHasGroups: boolean;

        public __env: any;
        public screen: ScreenUtils;
        private $scope: any;
        private $interval: any;
        private $window: any;
        private dialog: DialogUtils;
        private utils: Utils;
        private modelsUtils: any;
        private toast: ToastUtils;

        private navigationBarService: NavigationBarHelperService;
        private effortDataProvider: EffortDataProvider;
        private dataProvider: EventDataProvider;
        public userDataProvider: UserDataProvider;
        public permissionProvider: PermissionCheck;
        public groupDataProvider: GroupDataProvider;

        constructor(
            $scope: any,
            NavigationBarHelperService: NavigationBarHelperService,
            $interval: any,
            $window: any,
            $routeParams: any,
            UserDataProvider: UserDataProvider,
            EffortDataProvider: EffortDataProvider,
            EventDataProvider: EventDataProvider,
            DialogUtils: DialogUtils,
            PermissionCheck: PermissionCheck,
            __app_type: string,
            __env: any,
            Utils: Utils,
            CampaignDataProvider: CampaignDataProvider,
            GroupDataProvider: GroupDataProvider,
            ScreenUtils: ScreenUtils,
            ModelsUtils: any,
            ToastUtils: ToastUtils
        ) {
            Utils.accessCheck();
            this.$scope = $scope;
            this.$interval = $interval;
            this.$window = $window;
            this.__env = __env;
            this.dialog = DialogUtils;
            this.utils = Utils;
            this.screen = ScreenUtils;
            this.modelsUtils = ModelsUtils;
            this.toast = ToastUtils;

            this.navigationBarService = NavigationBarHelperService;
            this.userDataProvider = UserDataProvider;
            this.effortDataProvider = EffortDataProvider;
            this.dataProvider = EventDataProvider;
            this.permissionProvider = PermissionCheck;
            this.groupDataProvider = GroupDataProvider;

            this.navigationBarService.setSideBarOpen(false);
            this.navigationBarService.setAutoSidebar(false);

            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            this.isOrgCampaign =
                __app_type === "USER" &&
                this.activeCampaign.isOrganisationCampaign();
            this.view = ScreenUtils.medScreen() ? "form" : "both";

            this.permissions = PermissionCheck.levels;
            this.eventId = $routeParams.id;

            this.validationErrors = {
                image: this.validationError,
                starttimestamp: this.validationError,
                endtimestamp: this.validationError,
            };

            angular.forEach(this.permissions, (permission: any) => {
                permission.checked = false;
            });

            this.userDataProvider.clearAll();

            if (this.eventId) {
                this.dataProvider.info(this.eventId).then(
                    (event: EventModel) => {
                        this.event = event;
                        this.event.sendInvites = false;
                        this.selectEventStyle(
                            event.virtual == "1" ? "online" : "inperson"
                        );
                        this.getEfforts();

                        if (
                            this.event.attendance.invited.type === "permission"
                        ) {
                            angular.forEach(
                                this.permissions,
                                (permission: any) => {
                                    permission.checked =
                                        this.event.attendance.invited.permissions.filter(
                                            (p: any): boolean => {
                                                return (
                                                    p.permissionid ==
                                                    permission.permissionid
                                                );
                                            }
                                        ).length > 0;
                                }
                            );
                        }

                        if (this.event.attendance.invited.type === "team") {
                            this.event.attendance.invited.teams =
                                this.event.attendance.invited.teams.map(
                                    (team: any): Team => {
                                        return this.modelsUtils.team(team);
                                    }
                                );
                        }

                        this.event.attendance.invited.users = _.cloneDeep(
                            this.event.attendance.all.users
                        );
                    },
                    () => (this.eventError = true)
                );
            } else {
                this.event = this.modelsUtils.event();
                this.getEfforts();
            }

            let onRouteChangeOff = this.$scope.$on(
                "$locationChangeStart",
                (event: Event) => {
                    if (
                        this.event &&
                        this.event.name &&
                        this.event.name !== "" &&
                        !this.event.creating &&
                        !this.eventId
                    ) {
                        let answer = confirm(
                            "Are you sure you want to discard this action?"
                        );
                        if (!answer) {
                            event.preventDefault();
                        } else {
                            window.onbeforeunload = undefined;
                        }
                    }
                }
            );
            this.$scope.$on("$destroy", () => {
                onRouteChangeOff();
                window.onbeforeunload = undefined;
            });

            this.setUpWatchFunctions();

            this.groupFilter = new Filter({ search: "" });
            this.groupDataProvider.getAllGroups().then((groups: Group[]) => {
                this.groups = this.filterActiveGroups(groups);
                this.accountHasGroups = this.groups.length > 0;
            });
        }

        $onInit() {
            this.$scope.$watch(
                () => this.groupFilter.search,
                (newValue: string, oldValue: string) => {
                    if (newValue === oldValue) return;
                    if (!this.accountHasGroups) return;
                    this.groupDataProvider.getGroupsBy(this.groupFilter).then(
                        (filteredGroups: Group[]) => {
                            this.groups =
                                this.filterActiveGroups(filteredGroups);
                        },
                        (error: any) => {
                            if (error.message === "No data found") {
                                this.groups = [];
                                return;
                            }
                            this.toast.error();
                        }
                    );
                }
            );
        }

        setUpWatchFunctions(): void {
            this.$scope.$watch(
                () => {
                    return this.event
                        ? this.event.attendance.invited.type
                        : undefined;
                },
                (newValue: any, oldValue: any) => {
                    if (oldValue && newValue != oldValue) {
                        this.event.attendance.attending.users.splice(
                            0,
                            this.event.attendance.attending.users.length
                        );
                        this.event.attendance.attending.count = 0;

                        this.event.attendance.invited.users.splice(
                            0,
                            this.event.attendance.invited.users.length
                        );
                        this.event.attendance.invited.count = 0;

                        this.event.attendance.all.users.splice(
                            0,
                            this.event.attendance.invited.users.length
                        );
                        this.event.attendance.all.count = 0;
                    }
                },
                true
            );

            this.$scope.$watch(
                () => {
                    return this.event
                        ? this.event.attendance.invited.users
                        : undefined;
                },
                () => {
                    if (
                        this.event &&
                        this.event.attendance &&
                        this.event.attendance.invited.type == "user"
                    ) {
                        if (this.activeStep != 6) {
                            this.event.attendance.invited.count =
                                this.event.attendance.invited.users.length;
                        }
                    }
                },
                true
            );

            this.$scope.$watch(
                () => (this.event ? this.event.start : undefined),
                (oldValue: any, newValue: any) => {
                    if (oldValue != newValue) {
                        this.loadClashingEvents();
                    }
                },
                true
            );

            this.$scope.$watch(
                () => (this.event ? this.event.end : undefined),
                (oldValue: any, newValue: any) => {
                    if (oldValue != newValue) {
                        this.loadClashingEvents();
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.search.user,
                (newValue: User, oldValue: User) => {
                    if (oldValue != newValue) {
                        this.userDataProvider.loading = true;
                        if (this.searchDelay) {
                            this.searchDelay = this.$interval.cancel(
                                this.searchDelay
                            );
                        }
                        this.searchDelay = this.$interval(() => {
                            this.$interval.cancel(this.searchDelay);
                            this.filter.search = {
                                checked: true,
                                values: _.cloneDeep(this.search.user),
                            };

                            this.userDataProvider.setFilter(this.filter).then(
                                (users: User[]) => {
                                    if (
                                        this.event.attendance.invited.type !==
                                        "user"
                                    ) {
                                        this.filteredUsers = _.cloneDeep(users);
                                        return;
                                    }

                                    this.filteredUsers = [];
                                    angular.forEach(users, (user: any) => {
                                        angular.forEach(
                                            this.event.attendance.invited.users,
                                            (invitedUser: User) => {
                                                if (
                                                    invitedUser.uid == user.uid
                                                ) {
                                                    this.filteredUsers.push(
                                                        user
                                                    );
                                                }
                                            }
                                        );
                                    });
                                },
                                () => (this.filteredUsers = [])
                            );
                        }, 500);
                    }
                },
                true
            );
        }

        filterActiveGroups(groups: Group[]): Group[] {
            return groups.filter(
                (group: Group) =>
                    group.gstatus === "Active" || group.gstatus === "Inactive"
            );
        }

        getEfforts(): void {
            this.effortDataProvider
                .getAllEfforts()
                .then((efforts: Effort[]) => {
                    this.efforts = efforts.filter(
                        (effort: Effort) => effort.status == "Active"
                    );
                    if (this.eventId) {
                        this.event.effort = efforts.filter(
                            (effort: Effort) => effort.id == this.event.effortid
                        )[0];
                    } else {
                        this.effortDataProvider
                            .getSelectedEffort()
                            .then((effort: Effort) => {
                                if (effort.status != "Active") {
                                    this.event.effort = this.efforts[0];
                                } else {
                                    this.event.effort = effort;
                                }
                            });
                    }
                });
        }

        selectEventStyle(style: string): void {
            this.event.style = style;
            if (style === "online") {
                this.steps = [1, 2, 4, 5, 6];
                this.event.virtual = 1;
            } else {
                this.steps = [1, 2, 3, 4, 5, 6, 7];
                this.event.virtual = 0;
            }
        }

        onImageChange(): void {
            this.validationErrors = this.validationError;
        }

        onImageSaved(image: any): void {
            this.image = image;
        }

        toggleGroup(group: Group): void {
            if (this.isGroupSelected(group)) {
                const index = this.event.groups
                    .map((g: Group) => `${g.gid}`)
                    .indexOf(group.gid);
                this.event.groups.splice(index, 1);
            } else {
                this.event.groups.push(group);
            }
        }

        isGroupSelected(group: Group): boolean {
            if (this.event.groups) {
                const gids = this.event.groups.map((g: Group) => `${g.gid}`);
                return gids.includes(group.gid);
            }
            return false;
        }

        scrollLoad(lastHouse: any): void {
            if (this.event.attendance.invited.type === "user") return;

            if (!this.userDataProvider.scrollLoading) {
                this.userDataProvider
                    .getFilteredUsers(lastHouse, true)
                    .then((filteredUsers: User[]) => {
                        this.filteredUsers = _.cloneDeep(filteredUsers);
                    });
            }
        }

        userGoing(user: User): void {
            user.attending = !user.attending;
            angular.forEach(
                this.event.attendance.invited.users,
                (thisUser: User) => {
                    if (user.uid === thisUser.uid) {
                        thisUser.attending = user.attending;
                    }
                }
            );

            if (user.attending) {
                this.event.attendance.attending.users.push(user);
                return;
            }
            angular.forEach(
                this.event.attendance.attending.users,
                (thisUser: User, index: number) => {
                    if (user.uid === thisUser.uid) {
                        this.event.attendance.attending.users.splice(index, 1);
                    }
                }
            );
        }

        saveEvent(): void {
            this.event.creating = true;
            this.event.image = this.image;

            let data = _.cloneDeep(this.event);
            data.attendance.attending.users = [];
            data.attendance.attending.count = 0;
            data.attendance.waiting.users = [];
            data.attendance.waiting.count = 0;

            let count = 0;
            angular.forEach(
                this.event.attendance.invited.users,
                (user: User, index: number) => {
                    if (user.attending) {
                        data.attendance.invited.users.splice(index, 1);
                        if (data.licenses == 0 || count < data.licenses) {
                            data.attendance.attending.users.push(user);
                            data.attendance.attending.count =
                                data.attendance.attending.users.length;
                            count++;
                        } else {
                            data.attendance.waiting.users.push(user);
                            data.attendance.waiting.count =
                                data.attendance.waiting.users.length;
                        }
                    }
                }
            );

            if (this.event.attendance.invited.type !== "user") {
                data.attendance.invited.users = [];
            }

            if (data.id) {
                this.dataProvider.update(data).then(
                    () => (this.$window.location = "/#/events"),
                    (error: object) => {
                        this.event.creating = false;
                        this.backendValidation(error);
                    }
                );
            } else {
                this.dataProvider.create(data).then(
                    () => (this.$window.location = "/#/events"),
                    (error: object) => this.backendValidation(error)
                );
            }
        }

        backendValidation(error: any): void {
            const validators = {
                name: { step: 1 },
                description: { step: 1 },
                url: { step: 1, name: "videoCallLink" },
                image: {
                    step: 2,
                    apply: (message: string) => {
                        this.validationErrors.image.valid = false;
                        this.validationErrors.image.message = message;
                    },
                },
                location: { step: 3 },
                "location.description": { step: 3 },
                starttimestamp: {
                    step: 4,
                    apply: () =>
                        (this.datesError =
                            "Something's wrong with the start date and time"),
                },
                endtimestamp: {
                    step: 4,
                    apply: () =>
                        (this.datesError =
                            "Something's wrong with the end date and time"),
                },
                "effort.id": { step: 1 },
            };

            const errors = error.data.data || null;
            if (!errors) {
                return;
            }

            let step: number;
            for (const key in errors) {
                if (
                    typeof step === "undefined" ||
                    step > validators[key].step
                ) {
                    step = validators[key].step || 1;
                }

                let field = validators[key].name || key;
                let message = errors[key][0];

                if (typeof validators[field].apply === "function") {
                    validators[field].apply(message);
                } else {
                    this.createEventForm[field].$setValidity("invalid", false);
                    this.createEventForm[field].error = message;
                }
            }

            this.activeStep = step;
        }

        getErrorMessage(field: any, message: string): string {
            return (
                field.error ||
                message ||
                "Something went wrong. Please review this field."
            );
        }

        permissionChecked(permission: any): void {
            permission.checked = !permission.checked;
            this.event.attendance.invited.permissions = this.permissions.filter(
                (permission: any) => permission.checked
            );
        }

        removeUser(user: User, users: User[]): void {
            angular.forEach(users, (thisUser: User, $index: number) => {
                if (user.uid && user.uid == thisUser.uid) {
                    users.splice($index, 1);
                } else if (
                    user.campaigninviteemail &&
                    user.campaigninviteemail == thisUser.campaigninviteemail
                ) {
                    users.splice($index, 1);
                } else if (
                    user.campaigninvitephonenumber &&
                    user.campaigninvitephonenumber ==
                        thisUser.campaigninvitephonenumber &&
                    user.campaigninvitecountrycode ==
                        thisUser.campaigninvitecountrycode
                ) {
                    users.splice($index, 1);
                }
            });
        }

        removeTeam(team: Team, teams: Team[]): void {
            angular.forEach(teams, (thisTeam: Team, $index: number) => {
                if (team.tid && team.tid === thisTeam.tid) {
                    teams.splice($index, 1);
                }
            });
        }

        previousStep(): void {
            let index = 1;
            angular.forEach(this.steps, (step: number, $i: number) => {
                if (step === this.activeStep) {
                    index = $i;
                }
            });

            this.activeStep = this.steps[index + -1];

            if (this.activeStep < 1) {
                this.activeStep = 1;
            }
        }

        nextStep(): void {
            let valid = true;
            if (this.activeStep === 1) {
                this.createEventForm.videoCallLink.$setValidity(
                    "invalid",
                    true
                );

                if (!this.event.name || this.event.name == "") {
                    this.createEventForm.name.$setValidity("required", false);
                    valid = false;
                } else if (
                    this.event.style === "online" &&
                    (!this.createEventForm.videoCallLink.$valid ||
                        !this.event.url ||
                        this.event.url == "")
                ) {
                    this.createEventForm.videoCallLink.$setValidity(
                        "invalid",
                        false
                    );
                    valid = false;
                } else {
                    this.createEventForm.name.$setValidity("required", true);
                }
            } else if (this.activeStep === 2) {
                this.loadClashingEvents();
            } else if (this.activeStep === 4) {
                valid =
                    typeof this.event.start !== "undefined" &&
                    typeof this.event.end !== "undefined" &&
                    this.event.start.date != null &&
                    this.event.end.date != null;
                this.datesError = valid
                    ? ""
                    : "You need to set start and end dates for your action";
            } else if (this.activeStep === 5) {
                if (this.event.attendance.invited.type === "permission") {
                    this.permissionsError =
                        this.event.attendance.invited.permissions.length == 0
                            ? "You must select at least one permission"
                            : null;
                    valid = this.permissionsError === null;
                }
                if (this.event.attendance.invited.type === "user") {
                    this.usersError =
                        this.event.attendance.invited.users.length == 0
                            ? "You must select at least one user"
                            : null;
                    valid = this.usersError === null;
                }
                if (this.event.attendance.invited.type === "team") {
                    this.teamsError =
                        this.event.attendance.invited.teams.length == 0
                            ? "You must select at least one team"
                            : null;
                    valid = this.teamsError === null;
                }
            }

            if (valid) {
                let index: number = 0;
                angular.forEach(this.steps, (step: number, $i: number) => {
                    if (step === this.activeStep) {
                        index = $i;
                    }
                });
                this.activeStep = this.steps[index + 1];
            }

            if (this.activeStep === 6) {
                this.loadInvitedUsers();
            }
        }

        discard(): void {
            this.utils.navigateBack();
        }

        clearInvitedUsers(): void {
            this.event.attendance.invited.users = [];
            this.filteredUsers = [];
            this.event.attendance.attending.users = [];
            this.event.attendance.waiting.users = [];
        }

        loadInvitedUsers(): void {
            this.search.user = "";
            if (this.event.attendance.invited.type !== "user") {
                if (this.event.attendance.invited.type === "permission") {
                    this.filter = new Filter({
                        permission: {
                            checked: true,
                            values: this.event.attendance.invited.permissions.map(
                                (permission: any) => permission.permissionid
                            ),
                        },
                    });
                } else if (this.event.attendance.invited.type === "team") {
                    this.filter = new Filter({
                        teams: {
                            checked: true,
                            values: this.event.attendance.invited.teams.map(
                                (team: any) => team.tid
                            ),
                        },
                    });
                } else {
                    this.filter = new Filter();
                }

                this.userDataProvider.setFilter(this.filter).then(
                    (users: User[]) => {
                        this.event.attendance.invited.users.splice(
                            0,
                            this.event.attendance.invited.users.length
                        );
                        angular.forEach(users, (user: User) => {
                            user.attending = false;
                            angular.forEach(
                                this.event.attendance.attending.users,
                                (attendingUser: User) => {
                                    if (attendingUser.uid == user.uid) {
                                        user.attending = true;
                                    }
                                }
                            );
                            if (this.event.attendance.waiting) {
                                angular.forEach(
                                    this.event.attendance.waiting.users,
                                    (attendingUser: User) => {
                                        if (attendingUser.uid == user.uid) {
                                            user.attending = true;
                                        }
                                    }
                                );
                            }
                            this.event.attendance.invited.users.push(user);
                        });

                        this.userDataProvider
                            .getCount()
                            .then((count: number) => {
                                this.event.attendance.invited.count = count;
                                this.event.attendance.all.count = count;
                            });
                        this.filteredUsers = _.cloneDeep(
                            this.event.attendance.invited.users
                        );
                    },
                    (error: object) => {
                        if (error["message"] === "No data found") {
                            this.clearInvitedUsers();
                            return;
                        }
                        this.toast.error();
                    }
                );
            } else {
                this.userDataProvider.loading = false;
                this.event.attendance.invited.count =
                    this.event.attendance.invited.users.length;
                this.event.attendance.all.count =
                    this.event.attendance.invited.users.length;
                this.filteredUsers = _.cloneDeep(
                    this.event.attendance.invited.users
                );
                this.filter = new Filter();

                angular.forEach(
                    this.event.attendance.invited.users,
                    (user: User) => {
                        angular.forEach(
                            this.event.attendance.attending.users,
                            (attendingUser: User) => {
                                if (attendingUser.uid == user.uid) {
                                    user.attending = true;
                                }
                            }
                        );

                        if (this.event.attendance.waiting) {
                            angular.forEach(
                                this.event.attendance.waiting.users,
                                (attendingUser: User) => {
                                    if (attendingUser.uid == user.uid) {
                                        user.attending = true;
                                    }
                                }
                            );
                        }
                    }
                );
            }
        }

        loadClashingEvents(): void {
            if (this.event && this.event.start) {
                if (this.loadingClashingEvents == true) {
                    return;
                }

                this.loadingClashingEvents = true;
                this.dataProvider
                    .between(this.event.start.date, this.event.end.date)
                    .then((events: EventModel[]) => {
                        this.clashingEvents = [];
                        angular.forEach(events, (clashingEvent: EventModel) => {
                            if (
                                clashingEvent.status == "Active" &&
                                (!this.eventId ||
                                    clashingEvent.id != this.eventId)
                            ) {
                                this.clashingEvents.push(clashingEvent);
                            }
                        });

                        this.alreadyUsedLiceses = 0;
                        angular.forEach(
                            this.clashingEvents,
                            (event: EventModel) =>
                                (this.alreadyUsedLiceses += event.licenses)
                        );
                        this.loadingClashingEvents = false;
                    });
            }
        }
    },
};

angular
    .module("event")
    .component(CreateEventComponent.selector, CreateEventComponent);
